/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface CustomQuestionnaireAnswerCount
 */
export interface CustomQuestionnaireAnswerCount {
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof CustomQuestionnaireAnswerCount
   */
  useCaseCount: { [key: string]: number };
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof CustomQuestionnaireAnswerCount
   */
  questionnaireCount: { [key: string]: number };
}

/**
 * Check if a given object implements the CustomQuestionnaireAnswerCount interface.
 */
export function instanceOfCustomQuestionnaireAnswerCount(value: object): value is CustomQuestionnaireAnswerCount {
  if (!('useCaseCount' in value) || value['useCaseCount'] === undefined) return false;
  if (!('questionnaireCount' in value) || value['questionnaireCount'] === undefined) return false;
  return true;
}

export function CustomQuestionnaireAnswerCountFromJSON(json: any): CustomQuestionnaireAnswerCount {
  return CustomQuestionnaireAnswerCountFromJSONTyped(json, false);
}

export function CustomQuestionnaireAnswerCountFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomQuestionnaireAnswerCount {
  if (json == null) {
    return json;
  }
  return {
    useCaseCount: json['use_case_count'],
    questionnaireCount: json['questionnaire_count'],
  };
}

export function CustomQuestionnaireAnswerCountToJSON(value?: CustomQuestionnaireAnswerCount | null): any {
  if (value == null) {
    return value;
  }
  return {
    use_case_count: value['useCaseCount'],
    questionnaire_count: value['questionnaireCount'],
  };
}
